import React from 'react';
import { motion } from 'framer-motion';
import type { Tone } from '../types/snak';
interface ProgressRailProps {
  step: number;
  total: number;
  tone: Tone;
}
export function ProgressRail({
  step,
  total,
  tone
}: ProgressRailProps) {
  const pct = (step + 1) / total * 100;
  return <div className="flex items-center gap-3" role="progressbar" aria-valuemin={1} aria-valuemax={total} aria-valuenow={step + 1} aria-label="Snak progress" data-id="element-780" data-mp="22xq0i1fwklte">
      <div className={['h-[3px] flex-1 overflow-hidden rounded-full', tone === 'dark' ? 'bg-white/15' : 'bg-[rgba(1,51,43,0.10)]'].join(' ')} data-id="element-781" data-mp="1tx1lp4ioqhfg">
        <motion.div className={['h-full rounded-full', tone === 'dark' ? 'bg-primary' : 'bg-background'].join(' ')} animate={{
        width: `${pct}%`
      }} initial={false} transition={{
        type: 'spring',
        stiffness: 120,
        damping: 22
      }} data-id="element-782" data-mp="1k7i1nvj8khj0" />
      </div>
      <span className={['font-body text-[11px] tabular-nums tracking-[0.12em]', tone === 'dark' ? 'text-white/45' : 'text-[rgba(1,51,43,0.45)]'].join(' ')} data-id="element-783" data-mp="3plnmtk0ndw7g">
        {String(step + 1).padStart(2, '0')}/{String(total).padStart(2, '0')}
      </span>
    </div>;
}